import React from "react";
import { useTranslation } from "react-i18next";

const SelectCurrencyOverlay = ({ show }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        backgroundColor: "rgba(255,255,255,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "inherit",
        pointerEvents: "none",
      }}
    >
      <span
        style={{
          color: "#3A3541",
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          textAlign: "center",
          padding: "0 16px",
        }}
      >
        {t("analytics.selectCurrencyForStats")}
      </span>
    </div>
  );
};

export default SelectCurrencyOverlay;
